<template>
  <div class="row contacts-form">
    <div class="col-12">
      <div class="contacts-form_title">
        <p>Обратная связь для партнеров</p>
      </div>
    </div>
    <div class="col-12 col-md-8">
      <div class="contacts-form_controll">
        <label>Что бы вы хотели рассказать?</label>
        <STextArea v-model="formData.text" placeholder="Ваше сообщение" />
      </div>
    </div>
    <div class="col-12 col-md-4">
      <div class="contacts-form_controll">
        <label>Юридическое лицо<sup>*</sup></label>
        <SInput
          v-model="formData.name"
          :error="!!formErrors.name"
          :error-text="!!formErrors.name ? formErrors.name[0] : null"
          placeholder="Введите наименование юридического лица"
        />
      </div>
      <div class="contacts-form_controll">
        <label>Телефон для связи<sup>*</sup></label>
        <SInput
          v-model="formData.phone"
          :error="!!formErrors.phone"
          :error-text="!!formErrors.phone ? formErrors.phone[0] : null"
          placeholder="+7 (___) ___-__-__"
          mask="+7 (999) 999-99-99"
        />
      </div>
      <div class="contacts-form_controll">
        <Button
          v-text="'Отправить сообщение'"
          @click="sendContactsForm"
          class="button_mid"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SInput from '@/components/UI/Smart/Input'
import STextArea from '@/components/UI/Smart/TextArea'
import Button from '@/components/UI/Button'

export default {
  components: { SInput, STextArea, Button },
  data () {
    return {
      formData: {
        name: null,
        phone: null,
        text: null,
      },
    }
  },
  computed: {
    status () {
      return this.$store.getters['dictionaries/getStatus']
    },
    formErrors () {
      return this.$store.getters['dictionaries/getContactsFormErrors']
    },
  },
  watch: {
    status (newValue) {
      switch (newValue) {
        case 'contact-form-successfully-fetched':
          this.formData = {
            name: null,
            phone: null,
            text: null,
          }
          window.location.hash = 'contacts'
      }
    },
  },
  methods: {
    sendContactsForm () {
      this.$store.dispatch('dictionaries/sendContactsForm', this.formData)
    },
  },
}
</script>

<style lang="less">
.contacts-form {
	&_title {
		margin-bottom: 20px;

		p {
			font-family: 'Roboto Slab', Arial, sans-serif;
			font-weight: 500;
			font-size: 25px;
		}
	}

	&_controll {
		margin-bottom: 28px;

		@media screen and (max-width: 768px) {
			display: flex;
			flex-direction: column;
			align-items: stretch;
			margin-bottom: 18px;

			.button { width: 100%; }
		}

		label {
			display: block;
			font-family: 'Roboto', Arial, sans-serif;
			font-weight: 300;
			font-size: 14px;
			padding-bottom: 13px;
		}

		.textarea {
			min-height: 220px;

			@media screen and (max-width: 768px) { min-height: 150px; }
		}
	}
}
</style>
